import React from "react";
import { bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { statusTagColor, statusTag } from "util/thirdPayment";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";

const colStyle =  {
    wordBreak : {
        whiteSpace: "normal",
        wordBreak: "break-word"
    }
}    

const VendorsLotPaymentsItem = ({ receibedThirdPayment, isDesktop }) =>
    receibedThirdPayment?.status !== "FORMAT_ERROR" && (
        <>
            {isDesktop ? (
            <>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <span style={colStyle.wordBreak}>
                        {receibedThirdPayment?.transactionNumber || "-"}
                    </span>
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <span style={colStyle.wordBreak}>
                        {receibedThirdPayment?.creditCbu}
                    </span>
                </GridTable.Data>
            </>
             ) : (
            <>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomText
                        text={receibedThirdPayment?.transactionNumber || "-"}
                        textType="TEXT"
                        className="ellipsis-id-coelsa"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomText text={receibedThirdPayment?.creditCbu} textType="TEXT" className="ellipsis" />
                </GridTable.Data>
              </>
            )}   
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                <CustomText text={receibedThirdPayment?.accountType} textType="TEXT" />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4}>
                <CustomText text={receibedThirdPayment?.creditCuit} textType="TEXT" className="ellipsis" />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 1} rowStart={isDesktop ? 1 : 5}>
                <CustomData
                    titleText="transfer.amountField.label"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            currency={receibedThirdPayment?.creditAmountCurrency}
                            quantity={receibedThirdPayment?.creditAmountQuantity}
                        />
                    }
                    valueTextType="TEXT"
                    valueClass="font-bold"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 6 : 1} rowStart={isDesktop ? 1 : 6}>
                <CustomText text={receibedThirdPayment?.voucher} textType="TEXT" />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 7 : 1} rowStart={isDesktop ? 1 : 7}>
                <CustomText
                    text={receibedThirdPayment?.reference ? receibedThirdPayment?.reference : "-"}
                    textType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                className="tags-double"
                columnStart={isDesktop ? 8 : 2}
                rowStart={1}
                rowWidth={1}
                alignX={isDesktop ? "center" : "end"}
                alignY="center">
                {receibedThirdPayment?.status === "PROCESSED_WITH_ERROR" ? (
                    <>
                        <InfoTag
                            type="info"
                            message={statusTag("PROCESSED")}
                            tagBackground={statusTagColor(receibedThirdPayment?.status)}
                        />
                        <InfoTag
                            type="info"
                            message={statusTag("WITH_ERROR")}
                            tagBackground={statusTagColor(receibedThirdPayment?.status)}
                        />
                    </>
                ) : (
                    <InfoTag
                        type="info"
                        message={statusTag(receibedThirdPayment?.status)}
                        tagBackground={statusTagColor(receibedThirdPayment?.status)}
                    />
                )}
            </GridTable.Data>
        </>
    );

VendorsLotPaymentsItem.propTypes = {
    receibedThirdPayment: shape(echeqPropTypes).isRequired,
    isDesktop: bool.isRequired,
};

export default VendorsLotPaymentsItem;
